import { userSlice } from "./userslice";

export default userSlice.reducer;